/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InsuranceEligibilityCheckReport } from './InsuranceEligibilityCheckReport';
import {
    InsuranceEligibilityCheckReportFromJSON,
    InsuranceEligibilityCheckReportFromJSONTyped,
    InsuranceEligibilityCheckReportToJSON,
} from './InsuranceEligibilityCheckReport';

/**
 * 
 * @export
 * @interface GenerateEligibilityCheckReport200Response
 */
export interface GenerateEligibilityCheckReport200Response {
    /**
     * 
     * @type {InsuranceEligibilityCheckReport}
     * @memberof GenerateEligibilityCheckReport200Response
     */
    data?: InsuranceEligibilityCheckReport;
}

/**
 * Check if a given object implements the GenerateEligibilityCheckReport200Response interface.
 */
export function instanceOfGenerateEligibilityCheckReport200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GenerateEligibilityCheckReport200ResponseFromJSON(json: any): GenerateEligibilityCheckReport200Response {
    return GenerateEligibilityCheckReport200ResponseFromJSONTyped(json, false);
}

export function GenerateEligibilityCheckReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateEligibilityCheckReport200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : InsuranceEligibilityCheckReportFromJSON(json['data']),
    };
}

export function GenerateEligibilityCheckReport200ResponseToJSON(value?: GenerateEligibilityCheckReport200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': InsuranceEligibilityCheckReportToJSON(value.data),
    };
}

